const colorNames = {
    aliceblue: '#f0f8ff',
    antiquewhite: '#faebd7',
    aqua: '#00ffff',
    aquamarine: '#7fffd4',
    azure: '#f0ffff',
    beige: '#f5f5dc',
    bisque: '#ffe4c4',
    black: '#000000',
    blanchedalmond: '#ffebcd',
    blue: '#0000ff',
    blueviolet: '#8a2be2',
    brown: '#a52a2a',
    burlywood: '#deb887',
    cadetblue: '#5f9ea0',
    chartreuse: '#7fff00',
    chocolate: '#d2691e',
    coral: '#ff7f50',
    cornflowerblue: '#6495ed',
    cornsilk: '#fff8dc',
    crimson: '#dc143c',
    cyan: '#00ffff',
    darkblue: '#00008b',
    darkcyan: '#008b8b',
    darkgoldenrod: '#b8860b',
    darkgray: '#a9a9a9',
    darkgreen: '#006400',
    darkkhaki: '#bdb76b',
    darkmagenta: '#8b008b',
    darkolivegreen: '#556b2f',
    darkorange: '#ff8c00',
    darkorchid: '#9932cc',
    darkred: '#8b0000',
    darksalmon: '#e9967a',
    darkseagreen: '#8fbc8f',
    darkslateblue: '#483d8b',
    darkslategray: '#2f4f4f',
    darkturquoise: '#00ced1',
    darkviolet: '#9400d3',
    deeppink: '#ff1493',
    deepskyblue: '#00bfff',
    dimgray: '#696969',
    dodgerblue: '#1e90ff',
    firebrick: '#b22222',
    floralwhite: '#fffaf0',
    forestgreen: '#228b22',
    fuchsia: '#ff00ff',
    gainsboro: '#dcdcdc',
    ghostwhite: '#f8f8ff',
    gold: '#ffd700',
    goldenrod: '#daa520',
    gray: '#808080',
    green: '#008000',
    greenyellow: '#adff2f',
    honeydew: '#f0fff0',
    hotpink: '#ff69b4',
    indianred: '#cd5c5c',
    indigo: '#4b0082',
    ivory: '#fffff0',
    khaki: '#f0e68c',
    lavender: '#e6e6fa',
    lavenderblush: '#fff0f5',
    lawngreen: '#7cfc00',
    lemonchiffon: '#fffacd',
    lightblue: '#add8e6',
    lightcoral: '#f08080',
    lightcyan: '#e0ffff',
    lightgoldenrodyellow: '#fafad2',
    lightgray: '#d3d3d3',
    lightgreen: '#90ee90',
    lightpink: '#ffb6c1',
    lightsalmon: '#ffa07a',
    lightseagreen: '#20b2aa',
    lightskyblue: '#87cefa',
    lightslategray: '#778899',
    lightsteelblue: '#b0c4de',
    lightyellow: '#ffffe0',
    lime: '#00ff00',
    limegreen: '#32cd32',
    linen: '#faf0e6',
    magenta: '#ff00ff',
    maroon: '#800000',
    mediumaquamarine: '#66cdaa',
    mediumblue: '#0000cd',
    mediumorchid: '#ba55d3',
    mediumpurple: '#9370db',
    mediumseagreen: '#3cb371',
    mediumslateblue: '#7b68ee',
    mediumspringgreen: '#00fa9a',
    mediumturquoise: '#48d1cc',
    mediumvioletred: '#c71585',
    midnightblue: '#191970',
    mintcream: '#f5fffa',
    mistyrose: '#ffe4e1',
    moccasin: '#ffe4b5',
    navajowhite: '#ffdead',
    navy: '#000080',
    oldlace: '#fdf5e6',
    olive: '#808000',
    olivedrab: '#6b8e23',
    orange: '#ffa500',
    orangered: '#ff4500',
    orchid: '#da70d6',
    palegoldenrod: '#eee8aa',
    palegreen: '#98fb98',
    paleturquoise: '#afeeee',
    palevioletred: '#db7093',
    papayawhip: '#ffefd5',
    peachpuff: '#ffdab9',
    peru: '#cd853f',
    pink: '#ffc0cb',
    plum: '#dda0dd',
    powderblue: '#b0e0e6',
    purple: '#800080',
    red: '#ff0000',
    rosybrown: '#bc8f8f',
    royalblue: '#4169e1',
    saddlebrown: '#8b4513',
    salmon: '#fa8072',
    sandybrown: '#f4a460',
    seagreen: '#2e8b57',
    seashell: '#fff5ee',
    sienna: '#a0522d',
    silver: '#c0c0c0',
    skyblue: '#87ceeb',
    slateblue: '#6a5acd',
    slategray: '#708090',
    snow: '#fffafa',
    springgreen: '#00ff7f',
    steelblue: '#4682b4',
    tan: '#d2b48c',
    teal: '#008080',
    thistle: '#d8bfd8',
    tomato: '#ff6347',
    turquoise: '#40e0d0',
    violet: '#ee82ee',
    wheat: '#f5deb3',
    white: '#ffffff',
    whitesmoke: '#f5f5f5',
    yellow: '#ffff00',
    yellowgreen: '#9acd32',
    transparent: 'rgba(0,0,0,0)'
};
/**
 * Object.entries with typed return value
 * @param obj - The object to extract entries from.
 * @returns An array of key-value pairs from the object.
 * @public
 */ function objectEntries(obj) {
    return Object.entries(obj);
}
/**
 * Object.keys with typed return value
 * @param obj - The object to extract keys from.
 * @returns An array of keys from the object.
 * @public
 */ function objectKeys(obj) {
    return Object.keys(obj);
}
/**
 * Wrapper of a http get request
 * @public
 */ class HttpRequest {
    /** @internal */ static _tempElement = null;
    /** @internal */ _urlResolver;
    /** @internal */ _crossOrigin;
    /** @internal */ _headers;
    constructor(urlResolver){
        this._urlResolver = urlResolver ?? null;
        this._crossOrigin = '';
        this._headers = {};
    }
    /** Get the custom URL resolver */ get urlResolver() {
        return this._urlResolver;
    }
    set urlResolver(resolver) {
        this._urlResolver = resolver;
    }
    /** Get the cross origin property */ get crossOrigin() {
        return this._crossOrigin;
    }
    set crossOrigin(val) {
        this._crossOrigin = val;
    }
    /** Get the request headers */ get headers() {
        return this._headers;
    }
    set headers(val) {
        this._headers = val;
    }
    /**
   * Resolves a URL string.
   * @param url - The input url string,
   * @returns The resolved URL string.
   */ resolveURL(url) {
        if (!HttpRequest._tempElement) {
            HttpRequest._tempElement = document.createElement('a');
        }
        HttpRequest._tempElement.href = url;
        return HttpRequest._tempElement.href;
    }
    /**
   * Send a GET request.
   * @param url - The remote URL to fetch.
   * @returns The fetch result.
   */ async request(url) {
        url = this._urlResolver ? this._urlResolver(url) : this.resolveURL(url);
        return url ? fetch(url, {
            credentials: this._crossOrigin === 'anonymous' ? 'same-origin' : 'include',
            headers: this._headers || {}
        }) : null;
    }
    /**
   * Fetch a text string from remote.
   * @param url - The remote URL to fetch.
   * @returns The fetch result.
   */ async requestText(url) {
        const response = await this.request(url);
        if (!response?.ok) {
            throw new Error(`Asset download failed: ${url}`);
        }
        return response.text();
    }
    /**
   * Fetch a json object from remote.
   * @param url - The remote URL to fetch.
   * @returns The fetch result.
   */ async requestJson(url) {
        const response = await this.request(url);
        if (!response?.ok) {
            throw new Error(`Asset download failed: ${url}`);
        }
        return response.json();
    }
    /**
   * Fetch an array buffer from remote.
   * @param url - The remote URL to fetch.
   * @returns The fetch result.
   */ async requestArrayBuffer(url) {
        const response = await this.request(url);
        if (!response?.ok) {
            throw new Error(`Asset download failed: ${url}`);
        }
        return response.arrayBuffer();
    }
    /**
   * Fetch a blob object from remote.
   * @param url - The remote URL to fetch.
   * @returns The fetch result.
   */ async requestBlob(url) {
        const arrayBuffer = await this.requestArrayBuffer(url);
        return new Blob([
            arrayBuffer
        ]);
    }
}
/**
 * Simple assertion which throws an error if the !!condition is false.
 * @param condition - The condition to check.
 * @public
 */ function ASSERT(condition, message) {
    if (!condition) {
        throw new Error(message || 'Assertion failed');
    }
}
/**
 * Splits a string into an array of grapheme clusters (user-perceived characters).
 * @param text - The input string to split.
 * @returns An array of grapheme clusters.
 * @public
 */ function splitStringByGraphemes(text) {
    function isModifier(codePoint) {
        return codePoint === 0xfe0f || codePoint === 0x200d || codePoint >= 0x1f3fb && codePoint <= 0x1f3ff || codePoint >= 0x20d0 && codePoint <= 0x20ff;
    }
    const result = [];
    let i = 0;
    while(i < text.length){
        let grapheme = '';
        const codePoint = text.codePointAt(i);
        // Add primary character
        if (codePoint >= 0x10000) {
            grapheme += text.slice(i, i + 2);
            i += 2;
        } else {
            grapheme += text[i];
            i += 1;
        }
        // Add modifiers
        while(i < text.length && isModifier(text.codePointAt(i))){
            const modifierCodePoint = text.codePointAt(i);
            if (modifierCodePoint >= 0x10000) {
                grapheme += text.slice(i, i + 2);
                i += 2;
            } else {
                grapheme += text[i];
                i += 1;
            }
        }
        result.push(grapheme);
    }
    return result;
}
/**
 * Converts a Uint8Array to Base64 (Supports emoji character)
 * @param array - Uint8Array to convert
 * @returns Base64 string
 * @public
 */ function uint8ArrayToBase64(array) {
    let binaryString = '';
    for(let i = 0; i < array.length; i++){
        binaryString += String.fromCharCode(array[i]);
    }
    return btoa(binaryString);
}
/**
 * Converts a string to Base64 (Supports emoji character)
 * @param text - String to convert
 * @returns Base64 string
 * @public
 */ function textToBase64(text) {
    const encoder = new TextEncoder();
    const uint8Array = encoder.encode(text);
    return uint8ArrayToBase64(uint8Array);
}
/**
 * Converts a base64 string to text (Supports emoji character)
 * @param base64 - Base64 string to convert
 * @returns Original text
 * @public
 */ function base64ToText(base64) {
    const bytes = base64ToUint8Array(base64);
    return new TextDecoder('utf-8').decode(bytes);
}
/**
 * Converts a base64 string to Uint8Array (Supports emoji character)
 * @param base64 - Base64 string to convert
 * @returns Uint8Array
 * @public
 */ function base64ToUint8Array(base64) {
    const binaryString = atob(base64);
    const bytes = new Uint8Array(binaryString.length);
    for(let i = 0; i < binaryString.length; i++){
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
}
/**
 * Generate 128bit random UUID
 * @returns random UUID
 * @public
 */ function randomUUID() {
    if (crypto.randomUUID) {
        return crypto.randomUUID();
    } else {
        const rnds = new Uint8Array(16);
        crypto.getRandomValues(rnds);
        // Per RFC 4122 v4
        rnds[6] = rnds[6] & 0x0f | 0x40;
        rnds[8] = rnds[8] & 0x3f | 0x80;
        const hex = [
            ...rnds
        ].map((b)=>b.toString(16).padStart(2, '0'));
        return [
            hex.slice(0, 4).join(''),
            hex.slice(4, 6).join(''),
            hex.slice(6, 8).join(''),
            hex.slice(8, 10).join(''),
            hex.slice(10, 16).join('')
        ].join('-');
    }
}
/**
 * Check if a value is an instance of a specific constructor.
 * @param value - The value to check.
 * @param constructor - The constructor to check against.
 * @returns True if the value is an instance of the constructor, false otherwise.
 * @public
 */ function IS_INSTANCE_OF(value, constructor) {
    return value instanceof constructor;
}
/**
 * Check if a constructor is a subclass of another constructor.
 * @param derived - The derived constructor.
 * @param base - The base constructor.
 * @returns True if the derived is a subclass of the base, false otherwise.
 * @public
 */ function IS_SUBCLASS_OF(derived, base) {
    return !!(base && derived && (derived === base || base.prototype.isPrototypeOf(derived.prototype)));
}
/**
 * parse a css color value to RGBA color type.
 * @param input - The css color value.
 * @returns The RGBA color value.
 * @public
 */ function parseColor(input) {
    input = input.trim().toLowerCase();
    input = colorNames[input] || input;
    let v = null;
    if (input[0] === '#') {
        const collen = (input.length - 1) / 3;
        const fact = [
            17,
            1,
            0.062272
        ][collen - 1];
        v = {
            r: parseInt(input.substring(1, 1 + collen), 16) * fact / 255,
            g: parseInt(input.substring(1 + collen, 1 + 2 * collen), 16) * fact / 255,
            b: parseInt(input.substring(1 + 2 * collen, 1 + 3 * collen), 16) * fact / 255,
            a: 1
        };
    } else {
        let m;
        if (m = input.match(/^\s*rgb\s*\(\s*(\d*\.?\d*)\s*,\s*(\d*\.?\d*)\s*,\s*(\d\.?\d*)\s*\)\s*$/i)) {
            v = {
                r: Number(m[1]) / 255,
                g: Number(m[2]) / 255,
                b: Number(m[3]) / 255,
                a: 1
            };
        } else if (m = input.match(/^\s*rgba\s*\(\s*(\d*\.?\d*)\s*,\s*(\d*\.?\d*)\s*,\s*([\d*.?\d*]+)\s*,\s*(\d*\.?\d*)\s*\)\s*$/i)) {
            v = {
                r: Number(m[1]) / 255,
                g: Number(m[2]) / 255,
                b: Number(m[3]) / 255,
                a: Number(m[4])
            };
        }
    }
    if (!v || Number.isNaN(v.r) || Number.isNaN(v.g) || Number.isNaN(v.b) || Number.isNaN(v.a)) {
        throw new Error(`parseColor(): invalid color '${input}'`);
    }
    // the RGB color values in CSS are in sRGB color space, convert them to linear color space
    v.r = Math.pow(Math.min(1, v.r), 2.2);
    v.g = Math.pow(Math.min(1, v.g), 2.2);
    v.b = Math.pow(Math.min(1, v.b), 2.2);
    v.a = Math.min(1, v.a);
    return v;
}
/**
 * Applies mixins to a constructor function.
 *
 * @param target - The constructor function of the class that will receive the mixins.
 * @param mixins - mixins
 * @returns Mixed class
 *
 * @public
 */ function applyMixins(target, ...mixins) {
    let r = target;
    for (const m of mixins){
        r = m(r);
    }
    return r;
}
// Capture groups:
//  1: i$           -> explicit value index for the whole conversion
//  2: flagsStr
//  3: starWidth    -> '*' width specifier
//  4: widthIndex$  -> explicit width index, e.g. the 3 in `*3$`
//  5: widthNum     -> numeric width, e.g. `10`
//  6: starPrec     -> '*' precision specifier
//  7: precIndex$   -> explicit precision index, e.g. the 4 in `*4$`
//  8: precNum      -> numeric precision, e.g. `.2`
//  9: type
const formatRegex = /%(?:(\d+)\$)?([-+ 0#]*)(?:(\*)(?:(\d+)\$)?|(\d+))?(?:\.(?:(\*)(?:(\d+)\$)?|(\d+)))?([%sdifuoxXc])/g;
/**
 * Simple sprintf implementation:
 *
 * @param format - The format string
 * @param args - The format arguments
 * @returns The formatted string
 *
 * Supported format:
 * %%
 * %s
 * %c
 * %d, %i, %u
 * %f
 * %x, %X, %o
 *
 * Supported flags:
 * - (left align)
 * + (always show sign for number)
 *   (space if no sign for number)
 * 0 (zero pad)
 * # (alternate form, for x/X/o adds 0x/0X/0o prefix if value is non-zero)
 * * (width or precision from argument)
 * n$ (explicit argument index, 1-based)
 * .precision for s (max length)
 * .precision for d/i/u/x/X/o (min digits)
 * .precision for f (number of digits after decimal point, default 6)
 *
 * @example
 * ```ts
 * formatString('Hello %s', 'World'); // 'Hello World'
 * formatString('Hex: %#x', 255); // 'Hex: 0xff'
 * formatString('Width: %*d', 5, 42); // 'Width:    42'
 * formatString('Pi: %.2f', Math.PI); // 'Pi: 3.14'
 * formatString('Index: %2$s %1$s', 'first', 'second'); // 'Index: second first'
 * ```
 *
 * @public
 */ function formatString(format, ...args) {
    let out = '';
    let lastIndex = 0;
    let argIndex = 0;
    const readArg = (explicit)=>{
        if (explicit != null) {
            const idx = explicit - 1;
            if (idx < 0 || idx >= args.length) {
                throw new Error(`Argument index ${explicit}$ out of range`);
            }
            return args[idx];
        }
        if (argIndex >= args.length) {
            throw new Error('Too few arguments for format string');
        }
        return args[argIndex++];
    };
    const parseNumber = (val, name)=>{
        const n = typeof val === 'string' ? parseInt(val, 10) : Number(val);
        if (!Number.isFinite(n)) {
            throw new Error(`Invalid ${name}: ${val}`);
        }
        return n;
    };
    format.replace(formatRegex, (match, i$, flagsStr, starWidth, widthIndex$, widthNum, starPrec, precIndex$, precNum, type, offset)=>{
        out += format.slice(lastIndex, offset);
        lastIndex = offset + match.length;
        const token = {
            flags: {
                leftAlign: false,
                sign: false,
                space: false,
                zeroPad: false,
                alt: false
            },
            type
        };
        if (i$) {
            token.explicitIndex = parseInt(i$, 10);
        }
        // flags
        for (const ch of flagsStr || ''){
            switch(ch){
                case '-':
                    token.flags.leftAlign = true;
                    break;
                case '+':
                    token.flags.sign = true;
                    break;
                case ' ':
                    token.flags.space = true;
                    break;
                case '0':
                    token.flags.zeroPad = true;
                    break;
                case '#':
                    token.flags.alt = true;
                    break;
            }
        }
        // width
        if (starWidth) {
            token.widthFromArg = true;
            if (widthIndex$) {
                token.widthIndex = parseInt(widthIndex$, 10);
            }
        } else if (widthNum) {
            token.width = parseInt(widthNum, 10);
        }
        // precision
        if (starPrec) {
            token.precisionFromArg = true;
            if (precIndex$) {
                token.precisionIndex = parseInt(precIndex$, 10);
            }
        } else if (precNum) {
            token.precision = parseInt(precNum, 10);
        }
        const render = ()=>{
            const readIndex = (idx)=>readArg(idx);
            // read * parameter of width/precision
            if (token.widthFromArg) {
                const wArg = readIndex(token.widthIndex ?? token.explicitIndex);
                token.width = parseNumber(wArg, 'width');
            }
            if (token.precisionFromArg) {
                const pArg = readIndex(token.precisionIndex ?? token.explicitIndex);
                token.precision = parseNumber(pArg, 'precision');
                if (token.precision < 0) {
                    token.precision = undefined;
                }
            }
            const t = token.type;
            if (t === '%') {
                // literal %
                return '%';
            }
            const raw = readArg(token.explicitIndex);
            let body = '';
            let signStr = '';
            const asNumber = (v)=>{
                const n = typeof v === 'boolean' ? v ? 1 : 0 : v == null ? NaN : typeof v === 'string' && v.trim() === '' ? 0 : Number(v);
                return n;
            };
            const pad = (s, width, leftAlign, padChar = ' ')=>{
                if (!width || s.length >= width) {
                    return s;
                }
                const fill = padChar.repeat(width - s.length);
                return leftAlign ? s + fill : fill + s;
            };
            const prefixForAlt = (t)=>{
                if (t === 'x') {
                    return '0x';
                }
                if (t === 'X') {
                    return '0X';
                }
                if (t === 'o') {
                    return '0o';
                }
                return '';
            };
            switch(t){
                case 's':
                    {
                        body = String(raw ?? '');
                        if (token.precision != null) {
                            // precision: max length
                            body = body.slice(0, token.precision);
                        }
                        break;
                    }
                case 'c':
                    {
                        if (typeof raw === 'number') {
                            body = String.fromCharCode(raw);
                        } else {
                            const s = String(raw ?? '');
                            body = s.length ? s[0] : '\u0000';
                        }
                        break;
                    }
                case 'd':
                case 'i':
                    {
                        const n = asNumber(raw);
                        const isNeg = n < 0 || Object.is(n, -0);
                        const abs = Math.abs(n);
                        body = Math.trunc(abs).toString(10);
                        if (token.precision != null) {
                            body = '0'.repeat(Math.max(0, token.precision - body.length)) + body;
                        }
                        if (isNeg) {
                            signStr = '-';
                        } else if (token.flags.sign) {
                            signStr = '+';
                        } else if (token.flags.space) {
                            signStr = ' ';
                        }
                        body = signStr + body;
                        break;
                    }
                case 'u':
                    {
                        const n = asNumber(raw);
                        const u = n >>> 0; // unsigned 32-bit
                        body = u.toString(10);
                        if (token.precision != null) {
                            body = '0'.repeat(Math.max(0, token.precision - body.length)) + body;
                        }
                        break;
                    }
                case 'f':
                    {
                        const n = asNumber(raw);
                        const prec = token.precision ?? 6;
                        if (!Number.isFinite(n)) {
                            body = String(n);
                        } else {
                            body = n.toFixed(Math.max(0, Math.min(100, prec)));
                        }
                        if (n >= 0) {
                            if (token.flags.sign) {
                                body = '+' + body;
                            } else if (token.flags.space) {
                                body = ' ' + body;
                            }
                        }
                        break;
                    }
                case 'x':
                case 'X':
                case 'o':
                    {
                        const n = asNumber(raw);
                        const isUpper = t === 'X';
                        const abs = Math.trunc(Math.abs(n));
                        let str = t === 'o' ? abs.toString(8) : abs.toString(16);
                        if (isUpper) {
                            str = str.toUpperCase();
                        }
                        if (token.precision != null) {
                            str = '0'.repeat(Math.max(0, token.precision - str.length)) + str;
                        }
                        const pre = token.flags.alt && abs !== 0 ? prefixForAlt(t) : '';
                        body = pre + str;
                        break;
                    }
                default:
                    throw new Error(`Unsupported format type: ${t}`);
            }
            const useZeroPad = token.flags.zeroPad && !token.flags.leftAlign && token.type !== 's' && token.precision == null && token.type !== '%';
            if (useZeroPad) {
                const prefixMatch = body.match(/^([+\- ]|0x|0X|0o)/);
                const prefix = prefixMatch ? prefixMatch[0] : '';
                const rest = body.slice(prefix.length);
                body = prefix + pad(rest, token.width ? token.width - prefix.length : undefined, false, '0');
            } else {
                body = pad(body, token.width, token.flags.leftAlign, ' ');
            }
            return body;
        };
        out += render();
        return match;
    });
    out += format.slice(lastIndex);
    return out;
}

export { ASSERT, HttpRequest, IS_INSTANCE_OF, IS_SUBCLASS_OF, applyMixins, base64ToText, base64ToUint8Array, formatString, objectEntries, objectKeys, parseColor, randomUUID, splitStringByGraphemes, textToBase64, uint8ArrayToBase64 };
//# sourceMappingURL=utils.js.map
